import { Canvas } from "components";
import { models, modelSettings } from "models";

const Bedroom = () => {
    return <Canvas model={models.bedroom} settings={modelSettings.bedroom} />;
};

export default Bedroom;
